import apiClient from "./apiClient";

const Url = `/module-followup`;

export const listModuleFollowups = async (props, moduleName, recordId) => {
  try {
    const response = await apiClient.get(
      `${Url}/list?module=${encodeURIComponent(moduleName)}&recordId=${recordId}`,
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

export const addModuleFollowup = async (props, body) => {
  try {
    const response = await apiClient.post(Url, body);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const updateModuleFollowup = async (props, id, body) => {
  try {
    const response = await apiClient.put(`${Url}?id=${id}`, body);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const deleteModuleFollowup = async (props, id) => {
  try {
    const response = await apiClient.delete(`${Url}?id=${id}`);
    return response.data;
  } catch (error) {
    return error;
  }
};
